import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const ToastSuccess = (props) => (<Svg viewBox="0 0 20 20" fill="none" accessibilityRole="image" {...props}>
    <Path d="m12.267 7.325-3.575 3.583-1.375-1.375a.833.833 0 1 0-1.175 1.175L8.1 12.675a.834.834 0 0 0 1.175 0l4.167-4.167a.833.833 0 1 0-1.175-1.183ZM10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Zm0 15a6.667 6.667 0 1 1 0-13.334 6.667 6.667 0 0 1 0 13.334Z" fill="#fff"/>
  </Svg>);
export default ToastSuccess;
